import { useCallback } from 'react';
import { useResource } from 'hooks/useResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const useInvestorCommitments = (accountId) => {
	const fetchFn = useCallback(async () => {
		if (!accountId) return null;
		return await salesforceAccountsService.getInvestorCommitments(accountId);
	}, [accountId]);

	const { data, loading, error, refetch } = useResource({ fetchFn });

	return {
		commitments: data?.investor_commitments || [],
		loading,
		error,
		refetch,
	};
};

export default useInvestorCommitments;
